<template>
  <div>
    <v-app-bar
      :clipped-right="$vuetify.breakpoint.mobile"
      app
      elevate-on-scroll
      class="d-flex align-center justify-center flex-column"
      extension-height="38"
    >
      <!-- <v-btn v-ripple="false" icon>
        <v-icon class="opacity-0">mdi-arrow-left</v-icon>
      </v-btn> -->
      <!-- 뒤로가기 버튼 -->
      <v-btn v-if="hasBackButton" icon @click="clickBackButton">
        <v-icon>mdi-chevron-left</v-icon>
      </v-btn>
      <!-- local 모드에서만 보임? -->
      <!-- <v-app-bar-nav-icon
        v-else-if="$store.state.env?.mode === 'local' && isAuthenticated"
        @click.stop="drawer = !drawer"
      ></v-app-bar-nav-icon> -->
      <v-app-bar-nav-icon
        v-else-if="isAuthenticated"
        @click.stop="drawer = !drawer"
      ></v-app-bar-nav-icon>
      <v-btn v-else v-ripple="false" icon>
        <v-icon class="opacity-0">mdi-arrow-left</v-icon>
      </v-btn>

      <!-- 페이지 제목 -->
      <v-toolbar-title
        v-if="title"
        class="pl-0 font-size--18 color--gray-100 font-weight-bold text-center"
      >
        {{ title }}
      </v-toolbar-title>
      <!-- 제목없는 경우 로고 -->
      <v-toolbar-title v-else class="pl-0 text-center" :to="{ path: `/earlypay` }">
        <!-- <template v-if="headerTitle">
          {{ headerTitle }}
        </template>
        <template v-else> -->
        <router-link :to="{ path: `/earlypay` }">
          <LogoImage width="100px" />
        </router-link>
        <!-- </template> -->
      </v-toolbar-title>
      <!-- <v-btn v-else icon class="opacity-0">
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn> -->
      <v-app-bar-nav-icon disabled>
        <v-icon></v-icon>
      </v-app-bar-nav-icon>
      <!-- <v-app-bar-nav-icon @click="goClose">
        <v-icon>mdi-close</v-icon>
      </v-app-bar-nav-icon> -->

      <template v-if="isExtension" v-slot:extension>
        <div class="width-100">
          <SwitchAccount />
        </div>
      </template>
    </v-app-bar>
    <v-navigation-drawer v-model="drawer" app left fixed temporary v-if="isAuthenticated">
      <Left />
    </v-navigation-drawer>

    <!-- 제휴사 표시 띠배너 추가 -->
    <div v-if="organization && isShowBanner" class="affiliate-banner">
      {{organization.name}}와 제휴된 펀다에이아이의 금융서비스입니다
    </div>
  </div>
</template>
<script>
import { mapGetters, mapState, mapActions } from 'vuex'
import { closeBrowser } from '@/util'
import Left from './Left'

export default {
  components: {
    Left,
    SwitchAccount: () => import('@/components/auth/SwitchAccount.vue'),
  },
  data() {
    return {
      drawer: false,
    }
  },
  computed: {
    ...mapGetters('meta', { headerTitle: 'getHeaderTitle' }),
    ...mapGetters('auth', ['isAuthenticated']),
    ...mapState('auth', ['me', 'switchableAccounts']),
    ...mapState('ui/header', ['backAction', 'backTo']),
    ...mapState('myfinbiz', ['organization']),

    isMain() {
      return this.$route.name === 'main'
    },
    isSignin() {
      return this.$route.name === 'signin'
    },
    isInWebView() {
      return window.Android || window.webkit
    },
    isClose() {
      return (
        ['update', 'earlypay'].includes(this.$route.name) &&
        this.isAuthenticated &&
        this.isInWebView
      )
    },
    isExtension() {
      // 지금은 확장영역에 사업자 목록만 있음
      return this.isAuthenticated && this.switchableAccounts && this.switchableAccounts.length > 0
    },
    hasBackButton() {
      return this.$route.meta?.ui?.header?.backButton
    },
    title() {
      return this.$route.meta?.ui?.header?.title
    },
    isShowBanner() {
      return (
        this.$route.path.startsWith('/earlypay') ||
        this.$route.path.startsWith('/loan') ||
        this.$route.path.startsWith('/woori-crowd')
      )
    },
  },
  watch: {
    async me(v) {
      // 로그아웃시에 비활성화
      if (!v) {
        this.drawer = false
      } else {
        await this.getSwitchableAccounts()
      }
    },
  },
  methods: {
    ...mapActions('auth', ['getSwitchableAccounts']),
    historyBack() {
      if (!this.isMain) {
        this.$router.go(-1)
      }
    },
    goClose() {
      closeBrowser()
    },
    clickBackButton() {
      if (this.backTo) {
        this.$router.push(this.backTo)
        return
      } else if (this.backAction) {
        this.backAction()
      } else if (!this.isMain) {
        this.$router.go(-1)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/common/_variables.scss';

header {
  background-color: #ffffff !important;
}

.v-btn:before {
  opacity: 0 !important;
}

.v-ripple__container {
  opacity: 0 !important;
}
:deep(.v-toolbar__content) {
  max-width: $standard-max-width;
  width: 100%;
  justify-content: space-between;

  padding-left: 12px;
  padding-right: 12px;
}

:deep(.v-toolbar__extension) {
  max-width: $standard-max-width;
  width: 100%;
  justify-content: center;

  padding-left: 12px;
  padding-right: 12px;
}

.v-toolbar__title {
  width: 100%;
}

.affiliate-banner {
  position: fixed;
  top: 56px;
  left: 0;
  right: 0;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.8);
  color: white;
  font-size: 14px;
  padding: 8px;
  text-align: center;
  z-index: 4;
}

// extension이 있는 경우 위치 조정
:deep(.v-toolbar__extension) + .affiliate-banner {
  top: 94px;
}
</style>
